export default __webpack_public_path__ + "static/media/landing.14fbafb8.jpg";